import { indexItems } from '@/mocks/homeData';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
};

const iconBgMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-600',
  accent: 'bg-accent-100 text-accent-600',
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl lg:text-3xl font-heading font-bold text-foreground-950 mb-3">
            专题合集
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            按主题分类浏览你最感兴趣的吃瓜内容
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href="#updates"
              className="group flex items-start gap-4 p-5 bg-background-100 rounded-xl hover:bg-background-200/70 transition-colors cursor-pointer"
            >
              <div className={`w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0 ${iconBgMap[item.color]}`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                    {item.title}
                  </h3>
                  <span className={`text-[10px] px-1.5 py-0.5 rounded-full font-medium whitespace-nowrap ${colorMap[item.color]}`}>
                    {item.count}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}